// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * Official Repository: https://github.com/themesberg/volt-react-dashboard
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from './utils/UserContext';
import { AuthProvider } from './utils/AuthContext';
// core styles
import "./scss/volt.scss";

// vendor styles
import "react-datetime/css/react-datetime.css";
import { UnreadProvider } from './utils/UnreadContext';
import HomePage from "./pages/HomePage";


ReactDOM.render(
  <AuthProvider>
    <UserProvider>
      <UnreadProvider>
        <BrowserRouter >
          <HomePage />
        </BrowserRouter >
      </ UnreadProvider>
    </UserProvider>
  </AuthProvider>
  ,

  document.getElementById("root")
);
